import React, { useContext, useEffect, useMemo, useState } from "react";
import "./QuotesAndOrdersDynamicPage.css";
import ClientLeftSection from "components/ui/ClientFlow/clientLeftAndRightSection/ClientLeftSection";
import { useLocation, useParams } from "react-router-dom";
import ClientRightSection from "components/ui/ClientFlow/clientLeftAndRightSection/ClientRightSection";
import { Box, Divider, Skeleton } from "@mui/material";
import { useClientContext } from "context/ClientContext";
import SortContext from "context/SortContext";
import { useGlobalContext } from "context/GlobalContext";
import axios from "axios";
import { formatDateWithSuffix } from "utils/formatDate";
import { fetchAllOrderDesigns, fetchAllOrders, fetchSingleOrderDesign, fetchStatusWiseOrders } from "./Order/API/getOrderSummary";
import { useQuery } from "@tanstack/react-query";
import TransactionSmallCard from "components/ui/Skeleton/TransactionSmallCard";
import ProductSkeleton from "components/ui/Skeleton/ProductSkeleton";
import { fetchQuotesSummary , getAllQuotesDesign} from "./Quote/Api";

//---------- Converting Function -----------------\\
export function transformToItems(rawData) {
  return {
    items: rawData?.map((item) => ({
      Bags: item.BagCount ?? 0,
      DiaWt: item.DieWt ?? 0,
      NetWt: item.NetWt ?? 0,
      OrderDate: item.OrderDate ? item.OrderDate : "All",
      OrderNo: item.OrderNo,
      dueDate: "N/A",
    })),
  };
}

//Used in API File
export function convertOrderData(backendOrders, isSingleOrder) {
  return backendOrders.map((item) => {
    return {
      orderNo: item.BagBarcode || "",

      styleNo: item.StyleCode || "",

      ...(isSingleOrder ? {} : { orderRef: item.OrderNo }),

      location: item.CurrentDepartmentGroupCode ? `${item.CurrentDepartmentGroupCode}-${item.BagBarcode?.split("/").pop()}` : "",

      department: item.CurrentDepartmentName || "",

      quality: `${item.GoldQlty} / ${item.DiaQlty}`,

      ...(isSingleOrder ? {} : { dueDate: item.ExpDelDate ? formatDateWithSuffix(item.ExpDelDate) : "N/A" }),

      imageUrl: item.ImageUrl || item.ImageUrl || "",

      transformedImageUrl: item.TransformedImageUrl || item.TransformedImageUrl || "",

      expiryDate: item.ExpDelDate ? formatDateWithSuffix(item.ExpDelDate) : "N/A",
    };
  });
}

const QuotesAndOrdersDynamicPage = () => {
  const { status, clientId } = useParams();

  const [data, setData] = useState([]);
  const [selectedLeftCard, setSelectedLeftCard] = useState(null);
  const { setShowBagIcon, setBagCount, setDiaWeight, setGoldWeight } = useClientContext();
  const { setSearch } = useContext(SortContext);
  const { setSearchPlaceHolder } = useGlobalContext();
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const isOrdersPage = !!location?.state?.Orders;
  const isQuotesPage = !!location?.state?.Quotes;
  const isAllOrder = isOrdersPage && location?.state?.Orders === "All Orders";
  console.log("Location check===>>",location?.state?.Orders)

  // const completedQuotesdata = {
  //   items: [
  //     { Bags: 20, DiaWt: 21.11, NetWt: 311.175, OrderDate: "All", OrderNo: "All" },
  //     { Bags: 8, DiaWt: 11, NetWt: 120, OrderDate: "15th Mar, 2025", OrderNo: "CMP | 25 - 26 | 2990", dueDate: "15th May, 2025" },
  //   ],
  // };

  // const cancelledOrdersdata = {
  //   items: [
  //     { Bags: 19, DiaWt: 21.11, NetWt: 311.175, OrderDate: "All", OrderNo: "All" },
  //     { Bags: 2, DiaWt: 3, NetWt: 45, OrderDate: "10th Apr, 2025", OrderNo: "CNC | 25 - 26 | 3011", dueDate: "10th May, 2025" },
  //   ],
  // };

  // ---------------- QUOTES API ---------------- //
  const quoteStatusMap = {
    "Pending-quotes": "Pending",
    "All-quotes": "All",
    "Completed-quotes": "Completed",
    "Cancelled-quotes": "Cancelled",
  };

  const { data: quotesSummary, isFetching: isQuotesLoading } = useQuery({
    queryKey: ["quotesSummary", { clientId, status: quoteStatusMap[status] }],
    queryFn: fetchQuotesSummary,
    enabled: isQuotesPage,
  });

  // console.log("quotesSummary=======>>>>>",quotesSummary);

  const Quotesdata = {
    items: quotesSummary?.data,
  };

  const getData = () => {
    switch (status) {
      case "Pending-quotes":
        return Quotesdata;
      case "All-quotes":
        return Quotesdata;
      case "Completed-quotes":
        return Quotesdata;
      case "Cancelled-quotes":
        return Quotesdata;
      case "All-orders":
        return Quotesdata;
      case "Pending-orders":
        return Quotesdata;
      case "WIP-orders":
        return Quotesdata;
      case "Completed-orders":
        return Quotesdata;
      case "Cancelled-orders":
        return Quotesdata;
      default:
        return [];
    }
  };
  const getHeader = () => {
    switch (status) {
      case "Pending-quotes":
        return `Pending quote - ${quotesSummary?.totalCount || 0}`;
      case "All-quotes":
        return `All quotes - ${quotesSummary?.totalCount || 0}`;
      case "Completed-quotes":
        return `Completed quotes - ${quotesSummary?.totalCount || 0}`;
      case "Cancelled-quotes":
        return `Cancelled quotes - ${quotesSummary?.totalCount || 0}`;
      case "All-orders":
        return "All orders - 12";
      case "Pending-orders":
        return "Pending orders - 10";
      case "WIP-orders":
        return "WIP orders - 2";
      case "Completed-orders":
        return "Completed orders - 22";
      case "Cancelled-orders":
        return "Cancelled orders - 1";
      default:
        return "Details";
    }
  };
  const getType = () => {
    switch (status) {
      case "Pending-quotes":
        return "quote-order";
      case "All-quotes":
        return "quote-order";
      case "Completed-quotes":
        return "quote-order";
      case "Cancelled-quotes":
        return "quote-order";
      case "All-orders":
        return "quote-order";
      case "Pending-orders":
        return "quote-order";
      case "WIP-orders":
        return "quote-order";
      case "Completed-orders":
        return "quote-order";
      case "Cancelled-orders":
        return "quote-order";
      default:
        return "quote-order";
    }
  };

  const selectedItem = data?.items?.find((item) => item?.OrderNo === selectedLeftCard?.OrderNo);
  let dataForQuote = getData();
  const selectedItemForQuote = dataForQuote?.items?.find((item) => item?.OrderNo === selectedLeftCard?.OrderNo);
  // console.log("selectedItemForQuote====>>>>",selectedItemForQuote?.OrderNo)

  // useEffect(() => {
  //   if (dataForQuote) {
  //     const defaultCard = dataForQuote?.items?.find((item) => item.OrderNo === "All") || data.items[0];
  //     setSelectedLeftCard(defaultCard);
  //   }
  // }, [location]);

  //------- API Integration --------------\\

  const { data: leftCards = [], isFetching } = useQuery({
    queryKey: ["orders", clientId, isAllOrder ? "All" : location?.state?.Orders?.split(" ")[0]],
    queryFn: isAllOrder ? fetchAllOrders : fetchStatusWiseOrders,
    enabled: isOrdersPage,
  });

  useEffect(() => {
    if (leftCards?.length > 0) {
      setData(transformToItems(leftCards));
      setBagCount(leftCards[0]?.BagCount || 0);
      setDiaWeight(leftCards[0]?.DieWt || 0);
      setGoldWeight(leftCards[0]?.NetWt || 0);
    } else {
      setIsLoading(true);
    }
  }, [leftCards]);

  const orderNos = useMemo(() => {
    if (!leftCards.length) return [];
    return leftCards.filter((item) => item.OrderNo !== "All").map((item) => item.OrderNo);
  }, [leftCards]);

  const orderStatus =
  typeof location?.state?.Orders === "string"
    ? location.state.Orders.trim().split(/\s+/)[0]
    : "";

  const { data: allOrderDesigns = [], isLoading: isAllDesignLoading } = useQuery({
    queryKey: ["allDesigns", orderNos, orderStatus],
    queryFn: fetchAllOrderDesigns,
    enabled: selectedItem?.OrderNo === "All" && isOrdersPage && orderNos.length > 0,
  });

  const { data: singleOrderDesigns = [], isLoading: isSingleDesignLoading } = useQuery({
    queryKey: ["singleDesign", selectedItem?.OrderNo, orderStatus],
    queryFn: fetchSingleOrderDesign,
    enabled: selectedItem?.OrderNo !== "All" && isOrdersPage && !!selectedItem?.OrderNo,
  });

  useEffect(() => {
    setSearch(true);
    setSearchPlaceHolder("Search Transaction number");
    if (data?.items?.length > 0) {
      // const defaultCard = data.items.find((item) => item.OrderNo === "All") || data.items[0];
      // setSelectedLeftCard(defaultCard);
      setShowBagIcon(true);

      return () => {
        setShowBagIcon(false);
        setSearchPlaceHolder("");
        setSearch(false);
      };
    }
  }, [status, data]);

  useEffect(() => {
    return () => {
      setIsLoading(false);
    };
  }, []);

  // Right Side Data

  const allOrderNos = useMemo(() => {
    if (!quotesSummary?.data?.length) return [];
  
    return quotesSummary.data
      .map(item => item.OrderNo)
      .filter(orderNo => orderNo && orderNo !== "All");
  }, [quotesSummary]);
  
  
  const orderNosNew = useMemo(() => {
    if (!selectedLeftCard?.OrderNo) return [];
  
    if (selectedLeftCard.OrderNo === "All") {
      return allOrderNos;
    }
  
    return [selectedLeftCard.OrderNo];
  }, [selectedLeftCard, allOrderNos]);
  
  const payload = {
    orderNos: orderNosNew,
    sortBy: "StyleCode",
    sortOrder: "asc",
    searchBy: "",
    page: 1,
    limit: 30,
  };
  
  const {
    data: quoteDesignData,
    isLoading: isQuotesDesignLoading,
    isFetching: isQuotesDesignFetching,
    error,
  } = useQuery({
    queryKey: ["getAllQuotesDesign", payload],
    queryFn: getAllQuotesDesign,
    enabled: orderNosNew.length > 0 && !isOrdersPage,
    keepPreviousData: true,
  });
  
  // console.log("quoteDesignData===>>>",quoteDesignData)

  const mapQuotesData = (apiData = []) => {
    return apiData.map(item => ({
      styleNo: item.StyleCode,
      location: item.Item_PoNo || "-",
      quality: `${item.GoldQlty} ${item.GoldColor} / ${item.DiaQlty}`,
      transformedImageUrl: item.TransformedImageUrl,
      imageUrl: item.ImageUrl,
      SpecialRemarks: item.SpecialRemarks,
      StampInstruction: item.StampInstruction,
      CustomerProductionInstruction: item.CustomerProductionInstruction,
      DesignProductionInstruction: item.DesignProductionInstruction,
      Certificate: item.Certificate,
      Size: item.Size,
    }));
  };

  const mapAllQuotesData = (apiData = []) => {
    return apiData.map(item => ({
      styleNo: item.StyleCode,
      location: item.Item_PoNo || "-",
      quality: `${item.GoldQlty} ${item.GoldColor} / ${item.DiaQlty}`,
      transformedImageUrl: item.TransformedImageUrl,
      imageUrl: item.ImageUrl,
      orderRef: item.OrderNo || "-",
      dueDate: formatDateWithSuffix(item.ExpDelDate),
      SpecialRemarks: item.SpecialRemarks,
      StampInstruction: item.StampInstruction,
      CustomerProductionInstruction: item.CustomerProductionInstruction,
      DesignProductionInstruction: item.DesignProductionInstruction,
      Certificate: item.Certificate,
      Size: item.Size,
    }));
  };

  
  const quotesData = useMemo(
    () => mapQuotesData(quoteDesignData),
    [quoteDesignData]
  );


  const AllQuotesData = useMemo(
    () => mapAllQuotesData(quoteDesignData),
    [quoteDesignData]
  );
  
  const selectedRightDataForQuote = selectedLeftCard
    ? {
        header: `${selectedItemForQuote?.OrderNo} - ${selectedItemForQuote?.Bags}`,
        dueDate: selectedItemForQuote?.dueDate,
        items: selectedItemForQuote?.OrderNo === "All" ? AllQuotesData : quotesData,
      }
    : {
        header: "Select a card",
        items: [],
      };

  const selectedRightData = useMemo(() => {
    if (!selectedLeftCard || !selectedItem) return { header: "Select a card", items: [] };

    let items = [];
    let dueDate = "";

    if (selectedItem?.OrderNo === "All") {
      items = isOrdersPage ? allOrderDesigns : isQuotesPage ? AllQuotesData : [];
    } else {
      items = isOrdersPage ? singleOrderDesigns : isQuotesPage ? quotesData : [];
      dueDate = singleOrderDesigns[0]?.expiryDate;
    }

    return {
      header: `${selectedItem?.OrderNo} - ${selectedItem?.Bags}`,
      dueDate: dueDate,
      items,
    };
  }, [selectedLeftCard, selectedItem, allOrderDesigns, singleOrderDesigns, isOrdersPage, isQuotesPage]);

  return (
    <div className="quotes-order-container">
      <Divider sx={{ height: "4px", background: "#0D0D0D", borderBottom: "none", marginLeft: "-22px" }} />
      <div className="content-wrapper">
        {/* Left Section - Transactions - Takes 1/3 */}
        <div className="client-left-section">
          <ClientLeftSection
            data={isOrdersPage ? data : getData()}
            header={isOrdersPage ? `${isAllOrder ? "All" : location?.state?.Orders?.split(" ")[0]} orders - ${leftCards?.length - 1 || 0}` : getHeader()}
            type={getType()}
            selectedCard={selectedLeftCard}
            setSelectedCard={setSelectedLeftCard}
            isFetching={isFetching}
          />
        </div>
        <Divider orientation={"vertical"} sx={{ width: "4px", background: "#0D0D0D", border: "none", marginTop: "-20px" }} />
        {/* Right Section - Items - Takes 2/3 */}
        <div className="client-right-section">
          <ClientRightSection data={isOrdersPage ? selectedRightData : selectedRightDataForQuote} type={getType()} isLoading={isAllDesignLoading || isSingleDesignLoading || isQuotesDesignLoading} allData={isOrdersPage ? selectedRightData?.items : selectedRightDataForQuote?.items}/>
        </div>
      </div>
    </div>
  );
};

export default QuotesAndOrdersDynamicPage;
